import React from "react";
import {useSearchParams} from "react-router-dom";
import {useTaxYear} from "../../../contexts/TaxYearContext";

const SelectTaxYear = ({ availableYears = [], onSelectYear = null, includeText = false, customText = false }) => {
    const { taxYear, updateTaxYear } = useTaxYear();

    const handleSelectYear = (e) => {
        const newYear = e.target.value;
        // Update URL without navigation
        updateTaxYear(newYear);

        if(onSelectYear){
            onSelectYear(newYear);
        }
    }

    return (
        <div className="w-full sm:w-auto">
            {availableYears && (
                <select
                    id="yearSelect"
                    value={taxYear}
                    onChange={(e) => handleSelectYear(e)}
                    className="border border-gray-300 rounded-md px-3 py-1 text-sm bg-white dark:bg-gray-800 dark:border-gray-600 dark:text-gray-200"
                >
                    {customText ? (
                        availableYears.map((val, key) => (
                            <option key={key} value={val.year}>
                                {val.name} ({val.year})
                            </option>
                        ))
                    ) : (
                         availableYears.map((year) => (
                             <option key={year} value={year}>
                                 {includeText ? `Tax Preparation (${year})` : year}
                             </option>
                         ))
                     )}

                </select>
            )}

        </div>
    );
}

export default SelectTaxYear;
